var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title-wrapper"},[_c('span',[_vm._v(_vm._s(_vm.titleV))])])
}
var staticRenderFns = []

export { render, staticRenderFns }